document.addEventListener("DOMContentLoaded", function () {
    const e = document.querySelector(".halo-column.halo-column-product");
    if (!e) return;
    let t = Array.from(e.querySelectorAll(".halo-item"));
    t.forEach((e, t) => {
        e.querySelector(".stock-status .in-stock");
    });
    const a = t.sort((e, t) => {
        const a = e.querySelector(".stock-status .in-stock") ? 1 : 0,
            r = t.querySelector(".stock-status .in-stock") ? 1 : 0;
        return (
            e.querySelector(".stock-status .in-stock") || e.querySelector(".stock-status .out-of-stock") || console.warn(`⚠️ FIGYELEM: ${e.querySelector(".product-title")?.textContent.trim()} - nincs megfelelő stock-status osztály!`),
            t.querySelector(".stock-status .in-stock") || t.querySelector(".stock-status .out-of-stock") || console.warn(`⚠️ FIGYELEM: ${t.querySelector(".product-title")?.textContent.trim()} - nincs megfelelő stock-status osztály!`),
            r - a
        );
    });
    a.forEach((e, t) => {
        e.querySelector(".stock-status .in-stock");
    }),
        a.forEach((t) => e.appendChild(t));
}),
    document.addEventListener("DOMContentLoaded", function () {
        document.querySelectorAll(".swatch-element").forEach(function (e) {
            const t = e.getAttribute("data-value");
            if (!t) return;
            let a = "";
            if (
                (t.includes("1GB") && t.includes("16GB")
                    ? (a = "ALAP")
                    : t.includes("2GB") && t.includes("32GB")
                    ? (a = "STANDARD")
                    : t.includes("4GB") && t.includes("64GB")
                    ? (a = "PRO")
                    : t.includes("6GB") && t.includes("128GB")
                    ? (a = "ELITE")
                    : t.includes("8GB") && t.includes("128GB")
                    ? (a = "PRÉMIUM")
                    : t.includes("8GB") && t.includes("256GB") && (a = "PRÉMIUM+"),
                "" !== a)
            ) {
                e.setAttribute("version", a.toLowerCase());
                const t = e.querySelector("label");
                if (t) {
                    const e = document.createElement("span");
                    (e.className = "version-label"),
                        (e.textContent = a),
                        (e.style.display = "inline-block"),
                        (e.style.width = "95px"),
                        (e.style.textAlign = "center"),
                        (e.style.fontSize = "14px"),
                        (e.style.fontWeight = "bold"),
                        (e.style.textTransform = "uppercase"),
                        (e.style.backgroundColor = "#333"),
                        (e.style.color = "#fff"),
                        (e.style.borderRadius = "3px"),
                        (e.style.marginRight = "10px"),
                        (e.style.marginLeft = "-8px"),
                        (e.style.marginBottom = "0"),
                        t.prepend(e);
                }
            }
        }),
            document.querySelectorAll(".product_form_wrapper").forEach(function (e) {
                e.style.display = "block";
            });
    }),
    document.addEventListener("DOMContentLoaded", function () {
        const e = [
            [
                "4GB + 64GB",
                "4GB+ 64GB",
                "4GB 64GB",
                "4 + 64GB",
                "4+ 64GB",
                "4GB+64GB",
                "4GB+ 64",
                "4 GB + 64GB",
                "4 GB+ 64GB",
                "4 GB 64 GB",
                "4+64 GB",
                "4 +64GB",
                "4GB+64 GB",
                "4 GB +64 GB",
                "4GB 64GB Carplay",
                "4 GB+64GB Carplay",
                "4 + 64GB Carplay",
                "4+64GB Carplay",
                "4 GB +64GB Carplay",
                "4 GB+ 64GB Carplay",
                "4 gb + 64gb",
                "4gb 64gb",
                "4gb+ 64gb",
                "4 gb+64 gb",
                "4+64gb",
                "4 +64 gb",
                "4gb+64gb",
                "4 gb +64gb",
                "4+ 64 gb",
                "4GB+ 64GB Carplay WIFI 4G",
                "4GB 64GB Carplay WIFI 4G",
                "4GB+64GB Carplay WIFI 4G",
                "4GB +64GB Carplay WIFI 4G",
                "4GB + 64GB Carplay WIFI 4G",
                "4 GB+64 GB Carplay WIFI 4G",
                "4 GB 64 GB Carplay WIFI 4G",
                "4GB+64GBCarplay WIFI 4G",
                "4gb+64gb carplay wifi 4g",
                "4gb 64gb carplay wifi 4g",
                "4gb+64gbcarplay wifi 4g",
                "4gb +64gb carplay wifi 4g",
                "4GB+64GB Carplay Wifi 4G",
                "4GB 64GB Carplay Wifi 4G",
                "4GB+ 64GB Carplay Wifi 4G",
                "4GB+ 64GB Carplay WIFI",
                "4GB 64GB Carplay WIFI",
                "4GB+64GB Carplay WIFI",
                "4GB +64GB Carplay WIFI",
                "4GB + 64GB Carplay WIFI",
                "4 GB+64 GB Carplay WIFI",
                "4 GB 64 GB Carplay WIFI",
                "4GB+ 64GB Carplay WIFI",
                "4GB+64GBCarplay WIFI",
                "4gb+64gb carplay wifi",
                "4gb 64gb carplay wifi",
                "4gb+64gbcarplay wifi",
                "4gb +64gb carplay wifi",
                "4GB+64GB Carplay Wifi",
                "4GB 64GB Carplay Wifi",
                "4GB+ 64GB Carplay Wifi",
            ],
            [
                "2GB + 32GB",
                "2GB+ 32GB",
                "2GB 32GB",
                "2 + 32GB",
                "2+ 32GB",
                "2GB+32GB",
                "2GB+ 32",
                "2 GB + 32GB",
                "2 GB+ 32GB",
                "2 GB 32 GB",
                "2+32 GB",
                "2 +32GB",
                "2GB+32 GB",
                "2 GB +32 GB",
                "2GB 32GB Carplay",
                "2 GB+32GB Carplay",
                "2 + 32GB Carplay",
                "2+32GB Carplay",
                "2 GB +32GB Carplay",
                "2 GB+ 32GB Carplay",
                "2GB + 32GB Carplay",
                "2 gb + 32gb",
                "2gb 32gb",
                "2gb+ 32gb",
                "2 gb+32 gb",
                "2+32gb",
                "2 +32 gb",
                "2gb+32gb",
                "2 gb +32gb",
                "2+ 32 gb",
                "2GB+32GB Carplay WIFI",
                "2GB 32GB Carplay WIFI",
                "2GB+ 32GB Carplay WIFI",
                "2GB +32GB Carplay WIFI",
                "2GB + 32GB Carplay WIFI",
                "2 GB+32 GB Carplay WIFI",
                "2 GB 32 GB Carplay WIFI",
                "2GB+32GBCarplay WIFI",
                "2gb+32gb carplay wifi",
                "2gb 32gb carplay wifi",
                "2gb+32gbcarplay wifi",
                "2gb +32gb carplay wifi",
                "2GB+32GB Carplay Wifi",
                "2GB 32GB Carplay Wifi",
                "2GB+ 32GB Carplay Wifi",
            ],
        ];
        let t = null;
        for (let a of e) {
            for (let e of a) {
                const a = document.querySelectorAll(".swatch-element.size");
                for (let r of a)
                    if (r.getAttribute("data-value").toLowerCase() === e.toLowerCase() && r.classList.contains("new-available-class")) {
                        t = r;
                        break;
                    }
                if (t) break;
            }
            if (t) break;
        }
        if (!t)
            for (let a of e[1]) {
                const e = document.querySelectorAll(".swatch-element.size");
                for (let r of e)
                    if (r.getAttribute("data-value").toLowerCase() === a.toLowerCase() && r.classList.contains("new-available-class")) {
                        t = r;
                        break;
                    }
                if (t) break;
            }
        /*if (t && !t.querySelector(".best_product_badges")) {
            const e = document.createElement("div");
            e.className = "best_product_badges";
            const a = document.createElement("div");
            (a.className = "badge best-choice-badge"), (a.textContent = "🏆 TOP"), e.appendChild(a), (t.style.position = "relative"), t.appendChild(e);
        }*/
       // JAVÍTOTT ÉS KIBŐVÍTETT KÓD
        if (t && !t.querySelector(".best_product_badges")) {
            const bestBadgesContainer = document.createElement("div");
            bestBadgesContainer.className = "best_product_badges";
            
            const topBadge = document.createElement("div");
            topBadge.className = "badge best-choice-badge";
            topBadge.textContent = "🏆 TOP";
            
            bestBadgesContainer.appendChild(topBadge);
            t.style.position = "relative";
            t.appendChild(bestBadgesContainer);

            // === ÚJ LOGIKA KEZDETE ===
            // Ellenőrizzük, hogy az adott variációhoz tartozik-e akciós ("hot sale") kép.
            // A 't' változó maga a swatch-element, amiben keressük a képet.
            const hotSaleImage = t.querySelector('img[src*="hot-sale.png"]');
            
            // Ha létezik az akciós kép...
            if (hotSaleImage) {
                // ...akkor a "TOP" plecsnit eltoljuk jobbra, hogy ne fedjék egymást.
                topBadge.style.right = "-125px";
            }
            // Ha nem létezik, akkor a CSS-ben definiált alapértelmezett '-89px' érték marad érvényben.
            // === ÚJ LOGIKA VÉGE ===
        }
       /*if (t && !t.querySelector(".best_product_badges")) {
            const e = document.createElement("div");
            e.className = "best_product_badges";

            // DIV helyett IMG elemet hozunk létre
            const a = document.createElement("img");
            a.className = "best-choice-badge"; // Osztálynév a CSS-hez

            // Szöveg helyett beállítjuk a kép forrását és egy alternatív szöveget
            a.src = "https://cdn.shopify.com/s/files/1/0803/6142/3188/files/best-seller.png?v=1761385986";
            a.alt = "Bestseller"; // Fontos a keresőoptimalizálás és akadálymentesítés miatt

            e.appendChild(a);
            t.style.position = "relative";
            t.appendChild(e);
        }*/
    }), 
    document.addEventListener("DOMContentLoaded", function () {
        const e = document.querySelector(".buy-now-custom"),
            t = document.querySelector(".add-to-cart-with-accessories"),
            a = (document.querySelector(".product-accessories"), document.querySelectorAll(".cart-quantity[data-cart-count]")),
            r = document.querySelector('input[name="quantity"]'),
            o = document.querySelector(".cart-popup-wrapper"),
            n = document.querySelector(".cart-popup"),
            c = document.querySelector(".cart-popup-content"),
            i =
                (document.querySelector("[data-cart-popup-dismiss]"),
                document.querySelector("[data-cart-popup-close]"),
                document.getElementById("accessory-popup-overlay"),
                document.getElementById("close-popup"),
                document.getElementById("proceed-to-cart"),
                document.getElementById("skip-accessories"),
                []);
        function l(e, t) {
            e.preventDefault();
            const a = document.getElementById("selected-variant-id").getAttribute("data-selected-version");
            let r = null;
            if ("ALAP" === a) {
                const o = document.getElementById("upgrade-popup");
                if (o) {
                    o.classList.remove("hidden");
                    const n = o.querySelector("#upgrade-yes"),
                        c = o.querySelector("#upgrade-no");
                    return (
                        (n.onclick = function () {
                            o.classList.add("hidden");
                        }),
                        void (c.onclick = function () {
                            o.classList.add("hidden"), (r = document.getElementById("accessory-popup-overlay-alap")), (r.querySelector(".popup-title").textContent = a + " kiváló választás"), r.classList.remove("hidden");
                            const n = r.querySelector("#proceed-to-cart"),
                                c = r.querySelector("#skip-accessories");
                            (n.onclick = function () {
                                r.classList.add("hidden"), u(e, t);
                            }),
                                (c.onclick = async function (e) {
                                    e.preventDefault(), (i.length = 0), r.classList.add("hidden");
                                    try {
                                        await u(e, t),
                                            console.log("Fő termék sikeresen a kosárba került."),
                                            t &&
                                                setTimeout(() => {
                                                    (window.location.href = "/cart"), console.log("Átirányítás a kosár oldalra...");
                                                }, 1e3);
                                    } catch (e) {
                                        console.error("Hiba történt a 'Most kihagyom' funkcióban:", e), alert("Nem sikerült a terméket a kosárba adni.");
                                    }
                                });
                        })
                    );
                }
                r = document.getElementById("accessory-popup-overlay-alap");
            } else if ("STANDARD" === a) r = document.getElementById("accessory-popup-overlay-alap");
            else {
                if ("PRO" !== a && "ELITE" !== a && "PRÉMIUM" !== a && "PRÉMIUM+" !== a) return void console.error("Ismeretlen verzió: " + a);
                r = document.getElementById("accessory-popup-overlay-other");
            }
            (r.querySelector(".popup-title").textContent = a + " kiváló választás"), r.classList.remove("hidden");
            const o = r.querySelector("#proceed-to-cart"),
                n = r.querySelector("#skip-accessories");
            (o.onclick = function () {
                r.classList.add("hidden"), u(e, t);
            }),
                (n.onclick = async function (e) {
                    e.preventDefault(), (i.length = 0), r.classList.add("hidden");
                    try {
                        await u(e, t),
                            console.log("Fő termék sikeresen a kosárba került."),
                            t &&
                                setTimeout(() => {
                                    (window.location.href = "/cart"), console.log("Átirányítás a kosár oldalra...");
                                }, 1e3);
                    } catch (e) {
                        console.error("Hiba történt a 'Most kihagyom' funkcióban:", e), alert("Nem sikerült a terméket a kosárba adni.");
                    }
                });
        }
        async function s(e, t, a) {
            try {
                return await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: e, quantity: t }) }), a;
            } catch (e) {
                throw (console.error("Hiba történt a kosárba helyezéskor:", e), alert("Nem sikerült a terméket hozzáadni a kosárhoz."), e);
            }
        }
        async function d(e, t) {
            let a = `\n        <div class="cart-popup-item">\n            <img src="${document
                .getElementById("selected-variant-id")
                .getAttribute(
                    "data-product-image"
                )}" alt="${e}" class="cart-popup-img">\n            <div class="cart-popup-details">\n                <strong class="cart-popup-name">${e}</strong>\n                <p class="cart-popup-message">bekerült a kosárba! 🎉</p>\n            </div>\n        </div>`;
            t.length > 0 &&
                ((a += '<ul class="cart-popup-accessories">'),
                t.forEach((e) => {
                    a += `<li class="cart-popup-accessory">+ ${e}</li>`;
                }),
                (a += "</ul>")),
                (c.innerHTML = a),
                o.classList.remove("cart-popup-wrapper--hidden"),
                setTimeout(() => {
                    o.classList.add("cart-popup-wrapper--hidden"), (c.innerHTML = "");
                }, 3e3);
        }
        async function u(e, t = !1) {
            e.preventDefault();
            const o = Math.max(parseInt(r.value) || 1, 1),
                n = (function () {
                    const e = document.getElementById("selected-variant-id");
                    if (e) {
                        const t = e.getAttribute("data-variant-id");
                        if (t) return parseInt(t);
                    }
                    return console.error("Nem található kijelölt variáció az elemben."), null;
                })();
            if (!n) return void alert("Kérjük, válassz ki minden szükséges opciót!");
            const c = (function () {
                    const e = document.querySelector(".product_shop");
                    if (!e) return console.error("Nem található a termék szekció."), "Termék";
                    const t = e.querySelector(".product-title");
                    return t?.textContent.trim() || "Termék";
                })(),
                l = [];
            try {
                await s(n, o, c);
                for (const e of i) {
                    const t = document.querySelector(`.add-accessory-btn[data-id='${e}']`);
                    if (t) {
                        const a = t.closest(".accessory-item").querySelector(".accessory-name").innerText;
                        await s(e, o, a), l.push(a);
                    }
                }
                await (async function () {
                    try {
                        const e = await fetch("/cart.js");
                        if (!e.ok) throw new Error("Nem sikerült lekérni a kosár adatait.");
                        const t = (await e.json()).item_count;
                        a.forEach((e) => {
                            (e.textContent = t), e.setAttribute("data-cart-count", t);
                        });
                    } catch (e) {}
                })(),
                    t || (await d(c, l)),
                    t && (window.location.href = "/cart");
            } catch (e) {
                console.error("Hiba történt a hozzáadás során:", e);
            }
        }
        document.querySelectorAll(".add-accessory-btn").forEach((e) => {
            e.addEventListener("click", function () {
                const e = parseInt(this.getAttribute("data-id"));
                i.includes(e) || (i.push(e), (this.innerText = " ✅ Hozzáadva"), (this.disabled = !0), this.classList.add("added"));
            });
        });
        const selectedVariant = document.getElementById("selected-variant-id");
        const p = selectedVariant && selectedVariant.getAttribute("data-selected-version")?.trim() !== "";
        a.length &&
            r &&
            o &&
            n &&
            c &&
            (t &&
                t.addEventListener("click", function (e) {
                    p ? l(e, !1) : u(e, !1);
                }),
            e &&
                e.addEventListener("click", async function (e) {
                    e.preventDefault();
                    try {
                        await fetch("/cart/clear.js", { method: "POST" }), console.log("🗑️ Kosár sikeresen kiürítve."), p ? l(e, !0) : await u(e, !0);
                    } catch (e) {
                        console.error("❌ Hiba történt a kosár ürítésekor vagy a kosárba helyezéskor:", e), alert("Hiba történt a rendelés indításakor. Próbáld újra.");
                    }
                }));
    }),
// ===================================================================
//   EZT A TELJES BLOKKOT CSERÉLD LE A CUSTOM.JS FÁJLODBAN
// ===================================================================
document.addEventListener("DOMContentLoaded", function () {
    const e = document.querySelector("span.total-money"),
        t = document.getElementById("custom-total-price"),
        a = document.querySelector(".product-accessories"),
        r = document.querySelector('input[name="quantity"]'),
        o = document.querySelector(".minus"),
        n = document.querySelector(".plus"),
        c = document.getElementById("selected-variant-id"),
        i = document.getElementById("product-variants");

    if (!c || !i) return;

    function l(e) {
        const number = parseInt(e);
        if (isNaN(number)) return "0 Ft";
        //return number.toLocaleString("hu-HU") + "Ft";
        return number.toLocaleString("hu-HU").replace(/\s/g, '.') + "Ft";
    }

    function s() {
        if (!r) return 1;
        return Math.max(parseInt(r.value) || 1, 1);
    }

    function d() {
        const variantId = c.getAttribute("data-variant-id");
        if (!variantId) return;

        const variantItem = i.querySelector(`.variant-item[data-variant-id="${variantId}"]`);
        if (!variantItem) return;

        const variantPrice = parseFloat(variantItem.getAttribute("data-variant-price")) || 0;
        const variantComparePrice = parseFloat(variantItem.getAttribute("data-variant-compare-price")) || 0;
        const quantity = s();

        let accessoriesPrice = 0;
        if (a) {
            a.querySelectorAll('input[name="accessory_ids[]"]:checked').forEach((checkbox) => {
                accessoriesPrice += parseFloat(checkbox.getAttribute("data-price")) || 0;
            });
        }
        
        let total = (variantPrice + accessoriesPrice) * quantity;
        
        if (e) e.textContent = l(variantPrice);
        if (t) t.textContent = l(total);

        // =========================================================================
        // ===            STABIL ÉS KÖZÉPRE IGAZÍTOTT ÁRMEGJELENÍTŐ              ===
        // =========================================================================
        const priceWrapper = document.querySelector('#product-price-container .price-wrapper');
        const currentPriceEl = document.querySelector('#product-price-container .current-price');
        const comparePriceEl = document.querySelector('#product-price-container .compare-price');
        const savingsEl = document.querySelector('#product-price-container .savings-amount');
        
        if (priceWrapper && currentPriceEl && comparePriceEl && savingsEl) {
            currentPriceEl.textContent = l(variantPrice);

            // Ellenőrizzük, hogy akciós-e a termék
            if (variantComparePrice > variantPrice) {
                // Eredeti ár beállítása és láthatóvá tétele
                comparePriceEl.textContent = l(variantComparePrice);
                comparePriceEl.style.visibility = 'visible';

                // Akciós ár színének pirosra váltása
                currentPriceEl.classList.add('on-sale');

                // Megtakarítás kiszámítása és láthatóvá tétele
                const savings = variantComparePrice - variantPrice;
                savingsEl.textContent = `Megtakarítás: -${l(savings)}`;
                savingsEl.style.visibility = 'visible';

            } else {
                // Ha nem akciós, elrejtjük az elemeket, de a helyük megmarad
                comparePriceEl.style.visibility = 'hidden';
                savingsEl.style.visibility = 'hidden';
                
                // Akciós kiemelés eltávolítása (vissza a fekete színre)
                currentPriceEl.classList.remove('on-sale');
            }
        }
    }
    
    // Eseményfigyelők regisztrálása
    if (o) o.addEventListener("click", function(e){ e.preventDefault(); r.value=Math.max(s()-1,1); d(); });
    if (n) n.addEventListener("click", function(e){ e.preventDefault(); r.value=s()+1; d(); });
    if (r) r.addEventListener("input", function(){ r.value=r.value.replace(/[^0-9]/g,""); d(); });
    if (a) a.addEventListener("change", d);
    
    new MutationObserver(d).observe(c, { attributes: true });

    d(); // Kezdő állapot beállítása
}),
    document.addEventListener("DOMContentLoaded", function () {
        function e() {
            document.querySelectorAll(".money").forEach(function (e) {
                let t = e.innerHTML,
                    a = t.replace(/,/, " ");
                t !== a && (e.innerHTML = a);
            });
        }
        e(),
            new MutationObserver(() => {
                e();
            }).observe(document.body, { childList: !0, subtree: !0 });
    }),
    document.addEventListener("DOMContentLoaded", function () {
        window.location.origin,
            window.location.pathname,
            document.querySelectorAll('a[id^="product-link"]').forEach((e) => {
                e.href = e.href.split("?")[0].split("#")[0];
            });
    }),
    document.addEventListener("DOMContentLoaded", function () {
        const productPath = window.location.pathname;
        const variantIdMatch = productPath.match(/\/products\/[^\/]+\/(\d{14})$/);
        if (variantIdMatch) {
            const cleanUrl = productPath.replace(/\/\d{14}$/, "");
            window.history.replaceState({}, "", cleanUrl);
        }
    });


/* =================================================================== */
/*   SZÁLLÍTÁSI DÁTUM SZÁMÍTÓ SCRIPT (ÜNNEPNAP KEZELÉSSEL)             */
/* =================================================================== */
document.addEventListener('DOMContentLoaded', () => {

    // --- CÉL ELEMEK MEGHATÁROZÁSA ---
    const stockStatusElement = document.getElementById('product-availability');
    const deliveryContainer = document.getElementById('delivery-date-container');
    
    if (!stockStatusElement || !deliveryContainer) {
        console.warn('Szállítási dátum hiba: A #product-availability vagy #delivery-date-container elem hiányzik.');
        return;
    }

    // --- BEÁLLÍTÁSOK ÉS ÜNNEPNAPOK ---

    // !!!! FONTOS: IDE ÍRJA BE AZ ÜNNEPNAPOKAT ÉS NEM MUNKANAPOKAT !!!!
    // A formátum mindig: 'ÉÉÉÉ-HH-NN'
    const PUBLIC_HOLIDAYS = [
    // 2025-ös magyar ünnepnapok (munkanapokra esők)
    '2025-01-01', // Újév (szerda)
    '2025-04-18', // Nagypéntek (péntek)
    '2025-04-21', // Húsvéthétfő (hétfő)
    '2025-05-01', // A munka ünnepe (csütörtök)
    '2025-06-09', // Pünkösdhétfő (hétfő)
    '2025-08-20', // Államalapítás ünnepe (szerda)
    '2025-10-23', // 1956-os forradalom ünnepe (csütörtök)
    '2025-12-25', // Karácsony (csütörtök)
    '2025-12-26', // Karácsony másnapja (péntek)

    // 2026-os magyar ünnepnapok (munkanapokra esők)
    '2026-01-01', // Újév (csütörtök)
    '2026-04-03', // Nagypéntek (péntek)
    '2026-04-06', // Húsvéthétfő (hétfő)
    '2026-05-01', // A munka ünnepe (péntek)
    '2026-05-25', // Pünkösdhétfő (hétfő)
    '2026-08-20', // Államalapítás ünnepe (csütörtök)
    '2026-10-23', // 1956-os forradalom ünnepe (péntek)
    '2026-12-25', // Karácsony (péntek)

    // 2027-es magyar ünnepnapok (munkanapokra esők)
    '2027-01-01', // Újév (péntek)
    '2027-03-15', // Nemzeti ünnep (hétfő)
    '2027-03-26', // Nagypéntek (péntek)
    '2027-03-29', // Húsvéthétfő (hétfő)
    '2027-05-17', // Pünkösdhétfő (hétfő)
    '2027-08-20', // Államalapítás ünnepe (péntek)
    '2027-11-01', // Mindenszentek (hétfő)
    ];


    const ORDER_CUTOFF_HOUR = 13;
    const HUN_MONTHS_SHORT = ['jan.', 'feb.', 'márc.', 'ápr.', 'máj.', 'jún.', 'júl.', 'aug.', 'szept.', 'okt.', 'nov.', 'dec.'];
    
    // --- SEGÉDFÜGGVÉNYEK ---

    /**
     * **ÚJ FUNKCIÓ**
     * Ellenőrzi, hogy egy adott nap ünnepnap-e.
     * @param {Date} date - Az ellenőrizendő dátum.
     * @returns {boolean} - Igaz, ha ünnepnap.
     */
    function isHoliday(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return PUBLIC_HOLIDAYS.includes(`${year}-${month}-${day}`);
    }
    
    /**
     * **FRISSÍTETT FUNKCIÓ**
     * Munkanapokat ad hozzá egy dátumhoz, a hétvégéket ÉS az ünnepnapokat is kihagyva.
     * @param {Date} startDate - A kezdő dátum.
     * @param {number} days - A hozzáadandó munkanapok száma.
     * @returns {Date} - Az új, kiszámolt dátum.
     */
    function addWorkDays(startDate, days) {
        let date = new Date(startDate);
        let added = 0;
        while (added < days) {
            date.setDate(date.getDate() + 1);
            const dayOfWeek = date.getDay(); // 0=vasárnap, 6=szombat
            // Csak akkor számoljuk munkanapnak, ha nem hétvége ÉS nem ünnepnap.
            if (dayOfWeek !== 0 && dayOfWeek !== 6 && !isHoliday(date)) {
                added++;
            }
        }
        return date;
    }
    
    function formatShortDate(date) {
        return `${HUN_MONTHS_SHORT[date.getMonth()]} ${date.getDate()}`;
    }

    // --- FŐ LOGIKA: SZÁLLÍTÁSI DÁTUM FRISSÍTÉSE ---
    function updateDeliveryDate() {
        const now = new Date();
        let processingDate = new Date(now);

        // 1. A CSOMAGFELADÁS NAPJÁNAK MEGHATÁROZÁSA (alap számítás)
        if (now.getDay() === 6) { processingDate.setDate(now.getDate() + 2); } // Szombat -> Hétfő
        else if (now.getDay() === 0) { processingDate.setDate(now.getDate() + 1); } // Vasárnap -> Hétfő
        else if (now.getHours() >= ORDER_CUTOFF_HOUR) {
            processingDate.setDate(now.getDate() + (now.getDay() === 5 ? 3 : 1)); // Péntek 13:00 után -> Hétfő
        }
        
        // 2. **ÚJ LÉPÉS**: Biztosítjuk, hogy a feladási nap ne essen hétvégére vagy ünnepnapra
        while (processingDate.getDay() === 0 || processingDate.getDay() === 6 || isHoliday(processingDate)) {
             processingDate.setDate(processingDate.getDate() + 1);
        }

        // 3. KÉSZLETINFORMÁCIÓ KIOLVASÁSA
        const stockText = stockStatusElement.textContent || '';
        let deliveryStart, deliveryEnd;
        
        if (stockText.includes('Azonnal raktárról')) {
            deliveryStart = addWorkDays(processingDate, 1);
            deliveryEnd = addWorkDays(processingDate, 2);
        } else if (stockText.includes('2-5 munkanap')) {
            deliveryStart = addWorkDays(processingDate, 2);
            deliveryEnd = addWorkDays(processingDate, 5);
        } else {
            deliveryContainer.innerHTML = '';
            return;
        }

        // 4. EREDMÉNY MEGJELENÍTÉSE
        const formattedStart = formatShortDate(deliveryStart);
        const formattedEnd = formatShortDate(deliveryEnd);
        
        /*deliveryContainer.innerHTML = `
            <span class="delivery-icon">🚚</span>
            <span class="delivery-text">
                Expressz szállítás (GLS): <strong>${formattedStart} - ${formattedEnd}</strong>
            </span>
        `;*/
        deliveryContainer.innerHTML = `
    <img src="https://cdn.shopify.com/s/files/1/0803/6142/3188/files/GLS_Logo_2021_RGB_GLSBlue_-_white_background.svg?v=1761384076" alt="GLS Logo" style="height: 25px; margin-right: 12px;">
    <div>
        <span class="delivery-title">Expressz szállítás</span>
        <span class="delivery-arrival">Várható érkezés: <span class="delivery-date">${formattedStart} - ${formattedEnd}</span></span>
    </div>
`;
    }

    // --- FIGYELŐ BEÁLLÍTÁSA (OBSERVER) ---
    const observer = new MutationObserver(() => setTimeout(updateDeliveryDate, 50));
    observer.observe(stockStatusElement, { childList: true, subtree: true });

    updateDeliveryDate();
});